import PortalLayout from "../layout/PortalLayout";
import WelcomeCard from "./WelcomeCard";
import QuickActionsCard from "./QuickActionsCard";
import RefillReminderCard from "./RefillReminderCard";
import ActivityFeed from "./ActivityFeed";
import useHomeData from "./useHomeData";

export default function HomePage() {
  const data = useHomeData();

  return (
    <PortalLayout>
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

        <WelcomeCard
          loading={data.loading}
          user={data.user}
          activePrescriptionCount={data.activePrescriptionCount}
          pendingRefillCount={data.pendingRefillCount}
          totalPrescriptionCount={data.totalPrescriptionCount}
        />

        <QuickActionsCard />

        <div className="portal-grid-2" style={{ alignItems: "start" }}>
          <RefillReminderCard
            loading={data.loading}
            items={data.upcomingRefills}
          />
          <ActivityFeed
            loading={data.loading}
            items={data.activityFeed}
          />
        </div>

      </div>
    </PortalLayout>
  );
}
